<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div v-if="items != null">
    <EditDialog
      v-model="editDialog"
      :save-button-text="itemId === 'new' ? $t('create') : $t('save')"
      :title="itemId === 'new' ? $t('newWorkflow') : $t('editWorkflow')"
      :max-width="800"
      :transition="false"
      @save="loadItems"
    >
      <template v-slot:form="{ onSave, onError, needSave, needReset }">
        <WorkflowForm
          :project-id="projectId"
          :item-id="itemId"
          :need-save="needSave"
          :need-reset="needReset"
          @save="onSave"
          @error="onError"
        />
      </template>
    </EditDialog>

    <YesNoDialog
      :title="$t('deleteWorkflow')"
      :text="$t('askDeleteWorkflow')"
      v-model="deleteItemDialog"
      @yes="deleteItem(itemId)"
    />

    <v-toolbar flat>
      <v-app-bar-nav-icon @click="showDrawer()"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ $t('workflows') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="editItem('new')">{{ $t('newWorkflow') }}</v-btn>
    </v-toolbar>

    <v-divider />

    <v-data-table
      :headers="headers"
      :items="items"
      class="mt-4"
      :no-data-text="$t('noWorkflowsYet')"
      :footer-props="{ itemsPerPageOptions: [25, 50, 100] }"
    >
      <template v-slot:item.name="{ item }">
        <strong>{{ item.name }}</strong>
      </template>
      <template v-slot:item.nodes="{ item }">
        {{ nodeCount(item) }}
      </template>
      <template v-slot:item.actions="{ item }">
        <div style="white-space: nowrap">
          <v-btn icon class="mr-1" @click="runWorkflow(item)" :loading="runningId === item.id">
            <ZpIcon name="play" :size="18" />
          </v-btn>
          <v-btn icon class="mr-1" @click="editItem(item.id)">
            <ZpIcon name="edit-2" :size="18" />
          </v-btn>
          <v-btn icon class="mr-1" @click="askDeleteItem(item.id)">
            <ZpIcon name="trash-2" :size="18" />
          </v-btn>
        </div>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import axios from 'axios';
import ItemListPageBase from '@/components/ItemListPageBase';
import EditDialog from '@/components/EditDialog.vue';
import YesNoDialog from '@/components/YesNoDialog.vue';
import WorkflowForm from '@/components/WorkflowForm.vue';

export default {
  components: { EditDialog, YesNoDialog, WorkflowForm },
  mixins: [ItemListPageBase],

  data() {
    return { runningId: null };
  },

  methods: {
    getHeaders() {
      return [
        { text: this.$i18n.t('name'), value: 'name' },
        {
          text: this.$i18n.t('workflowNodes'), value: 'nodes', sortable: false, width: 100,
        },
        {
          text: '', value: 'actions', sortable: false, width: 150,
        },
      ];
    },
    getItemsUrl() {
      return `/api/project/${this.projectId}/workflow_templates`;
    },
    getSingleItemUrl() {
      return `/api/project/${this.projectId}/workflow_templates/${this.itemId}`;
    },
    getEventName() {
      return 'i-workflow';
    },
    nodeCount(item) {
      try {
        const def = JSON.parse(item.definition || '{}');
        return (def.nodes || []).length;
      } catch (e) {
        return 0;
      }
    },
    async runWorkflow(item) {
      this.runningId = item.id;
      try {
        const res = await axios.post(
          `/api/project/${this.projectId}/workflow_templates/${item.id}/run`,
        );
        this.$emit('snackbar', this.$t('workflowRunStarted', { id: res.data.id }));
      } catch (e) {
        this.$emit('snackbar', e.response?.data?.error || e.message);
      } finally {
        this.runningId = null;
      }
    },
  },
};
</script>
